import { z } from 'zod';

import { AttributesSchema, CharacterEntitySchema } from './characterEntity';
import { CharacterPresenceSchema } from './characterPresence';
import { CharacterProfileSchema } from './characterProfile';

export const CharacterSeedProfileOverridesSchema = CharacterProfileSchema.partial();
export type CharacterSeedProfileOverrides = z.infer<typeof CharacterSeedProfileOverridesSchema>;

export const CharacterSeedEntityOverridesSchema = CharacterEntitySchema.partial().extend({
  attributes: AttributesSchema.partial().optional(),
});
export type CharacterSeedEntityOverrides = z.infer<typeof CharacterSeedEntityOverridesSchema>;

export const CharacterSpawnPresenceOverridesSchema = CharacterPresenceSchema.partial();
export type CharacterSpawnPresenceOverrides = z.infer<typeof CharacterSpawnPresenceOverridesSchema>;
